// 2022-07-20T17:32:28.995118 变成 2022-07-20 17:32
export function formatOrdertime(orderTime) {
    return orderTime ? orderTime.substring(0, 16).replace('T', ' ') : '';
}
export function refundStateTag(state) {
    const statusMap = {
        1: 'primary',
        2: 'warning',
        3: 'success',
        '-1': 'error'
    };
    return statusMap[state] ? statusMap[state] : '';
}
// 两个浮点数求和
export function accAdd(num1, num2) {
    var r1, r2, m;
    try {
        r1 = num1.toString().split('.')[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = num2.toString().split('.')[1].length;
    } catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));

    return Math.round(num1 * m + num2 * m) / m;
}
// 客户账号状态  公共模板
export function user_status(state) {
    const statusMap = {
        on: '正常',
        off: '停用'
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function label_type_list(state) {
    const statusMap = {
        1: '产品码',
        2: '中盒码',
        3: '箱码',
       
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function is_active_list(state) {
    const statusMap = {
        true: '正常',
        false: '停用',
       
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function store_is_used_list(state) {
    const statusMap = {
        true: '已领取',
        false: '未领取',
       
    };
    return statusMap[state] ? statusMap[state] : '';
}

export function is_login_list(state) {
    const statusMap = {
        true: '是',
        false: '否',
       
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function auth_info_list(list) {
    if(list.length==0){
        return
    }
    let custom_auth_list = [
        {"pda":"pda"},
        {"homepage": "首页"},
        {"company":"公司"},
        {"product":"产品"},
        {"labelapply": "二维码申请"},
        {"labeltracking": "标签"},
        {"inbounddata": "入库明细"},
        {"outbounddata": "出库明细"},
        {"saleagent":"代理商管理"},
        {"saleagentinventory":"代理商库存"},
        {"store": "门店管理"},
        {"storeinbounddata": "门店入库"},
        {"saleagentch": "代理商串货统计"},
        {"abnormalscanlabellog":"串货二维码明细"},
        {"clientuser":'员工管理'},
        {"labelquery": "二维码查询"},
        {"storeorder": "门店订单"},
        {"userorder": '消费者订单'},
        {"goods": "商品列表"},
        {"goodscategory": "分类管理"},
        {"posterconfig": '轮播海报'},
    ]
    let names=[]
    custom_auth_list.map(item=>{
        for(let key in item){
          list.map(ite=>{
            if(key==ite){
              names.push(item[key])
            }
          })
        }
      })

    return names ? names.toString() : '';
}
export function user_type_list(state) {
    const statusMap = {
        super: '超级账户',
        admin: '管理员',
        user: '普通员工'
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function integral_category_list(state) {
    const statusMap = {
        add: '增加',
        decr: '减少',
    };
    return statusMap[state] ? statusMap[state] : '';
}

export function client_user_status_list(state) {
    const statusMap = {
        wait_audit: '待审核',
        passed: '审核成功',
        failed: '审核失败',
        ban: '黑名单'
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function client_user_status_type(state) {
    const statusMap = {
        wait_audit: 'info',
        passed: 'success',
        failed: 'warning',
        ban: 'danger'
    };
    return statusMap[state] ? statusMap[state] : '';
}

export function payment_use_merchant_withdraw_list(state) {
    const statusMap = {
        yes: '使用商户提现',
        no: '使用企业提现'
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function put_bloo(state) {
    const statusMap = {
        on: 'true',
        off: 'false'
    };
    return statusMap[state] ? statusMap[state] : '';
}
// # 用户来源
export function user_source_list(state) {
    const statusMap = {
        one_code: '一物一码',
        invite: '老用户邀请',
        other: '小程序及其它渠道',
        import: '导入'
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function user_sex_list(state) {
    const statusMap = {
        man: '男',
        woman: '女',
        unknown: '未知'
    };
    return statusMap[state] ? statusMap[state] : '';
}
// 用户积分类型
export function user_point_category_list(state) {
    const statusMap = {
        one_code: '一物一码',
        upgrade: '会员升级',
        'inner-incr': '人工-增加积分',
        outer: '第三方平台',
        full_activity: '满送活动',
        'inner-decr': '人工-减少积分',
        expire: '积分过期',
        buy_goods: '积分购买商品'
    };
    return statusMap[state] ? statusMap[state] : '';
}
// 手机号号码加空格
export function phone(state) {
    if (state) {
        return state.substr(0, 3) + ' ' + state.substr(3, 4) + ' ' + state.substr(7);
    }
}
// 金额取.后两位 不四舍五入
export function price(state) {
    if (state) {
        // 先截取当前数据到小数点后三位 （不会四舍五入）
        let tempVal = parseFloat(state).toFixed(3);
        // 再取该数值长度-1的内容
        let realVal = tempVal.substring(0, tempVal.length - 1);
        return realVal;
    }
}
// 数字千分位 加，
export function addCommas(num) {
    return num.toLocaleString();
}

// 金额千分位 加， 保留两位数
export function dealMoney(money, places = 2) {
    const zero = `0.00`;
    if (isNaN(money) || money === '') return zero;

    if (money && money != null) {
        money = `${money}`;
        let left = money.split('.')[0]; // 小数点左边部分
        let right = money.split('.')[1]; // 小数点右边
        // 保留places位小数点，当长度没有到places时，用0补足。
        right = right
            ? right.length >= places
                ? '.' + right.substr(0, places)
                : '.' + right + '0'.repeat(places - right.length)
            : '.' + '0'.repeat(places);
        var temp = left
            .split('')
            .reverse()
            .join('')
            .match(/(\d{1,3})/g); // 分割反向转为字符串然后最多3个，最少1个，将匹配的值放进数组返回
        return (Number(money) < 0 ? '-' : '') + temp.join(',').split('').reverse().join('') + right; // 补齐正负号和货币符号，数组转为字符串，通过逗号分隔，再分割（包含逗号也分割）反向转为字符串变回原来的顺序
    } else if (money === 0) {
        return zero;
    } else {
        return zero;
    }
}
export function freight_template_charge_type_list(state) {
    const statusMap = {
        weight: '按重量计费',
        number: '按件数计费',
        amount: '按金额计费',
    };
    return statusMap[state] ? statusMap[state] : '';
}



export function order_invoice_type_list(state) {
    const statusMap = {
        not_used: '不使用',
        personal: '个人',
        enterprise: '企业'
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function order_invoice_status_list(state) {
    const statusMap = {
        not_used: '不使用',
        not_invoiced: '未开票',
        invoiced: '已开票'
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function is_active(state) {
    const statusMap = {
        true: '正常',
        false: '停用'
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function order_status_list (state) {
    const statusMap = {
        cancel: '已取消',
        expired: '已过期',
        wait_pay: '待支付',
        paid: '待发货',
        portion: '部分发货',
        shipped: '已发货',
        finish: '已完成',
        evaluated:'已评价',
        closed: '已关闭',
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function order_source_list(state) {
    const statusMap = {
        normal : '普通订单',
        point: '积分订单',
        group: '团购订单',
        seckill: '秒杀订单',
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function order_product_refund_status_list(state) {
    const statusMap = {
        cancel : '取消申请',
        refuse : '拒绝申请',
        refund: '申请退款',
        return: '申请退货退款',
        returning: '待买家退货',//已同意/
        returned: '待退款',//已退货/
        refunding: '退款中',
        refunded: '已退款',
        failed: '退款失败',
        barter: '申请换货',
        agree_barter: '买家待上传快递信息',//同意换货/
        buyer_upload: '买家退货并上传快递单号',
        seller_confirm: '卖家收货并上传快递单号',
    };
    return statusMap[state] ? statusMap[state] : '暂无';
}

export function after_sales_order_category_list(state) {
    const statusMap = {
        refund : '退款',
        return: '退货退款',
        barter: '换货',
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function user_article_category_list(state) {
    const statusMap = {
        image : '图文',
        video: '视频',
        barter: '换货',
    };
    return statusMap[state] ? statusMap[state] : '';
}

export function express_info_company_list(state) {
    const statusMap = {
        韵达 : '韵达',
        顺丰: '顺丰',
        圆通: '圆通',
        百世: '百世',
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function user_identity_list(state) {
    const statusMap = {
        normal : '普通用户',
        blacklist: '黑名单',
       
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function order_statu1s(state) {
    const statusMap = {
        delivery : '待发货',
        delivered: '已发货',
        receive: '已领取',
       
    };
    return statusMap[state] ? statusMap[state] : '';
}

export function withdraw_log_status_list(state) {
    const statusMap = {
        audit : '待审核',
        refused: '已拒绝',
        passed: '已通过',
        processing: '提现中',
        failed: '打款失败',
        success: '打款成功',
       
    };
    return statusMap[state] ? statusMap[state] : '';
}

export function sales_unit_list(state) {
    const statusMap = {
        individual : '个',
        chest: '箱',
        packet: '包',
        bag: '袋',
    };
    return statusMap[state] ? statusMap[state] : '';
}

export function user_coupons_status_list(state) {
    const statusMap = {
        not_used : '未使用',
        expire: '已过期',
        used: '已使用',
      
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function display_location_list(state) {
    const statusMap = {
        homepage : '首页展示',
        product_page: '商品页首页展示',
        personal: '个人中心展示',
      
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function full_delivery_activity_category_list(state) {
    const statusMap = {
        full : '满送-阶梯送',
        every_full: '每满-循环送',
 
      
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function typeList(state) {
    const statusMap = {
        phone : '请输入手机号',
        nickname: '请输入昵称',
        name: '请输入姓名',
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function coupon_list_status(state) {
    const statusMap = {
        not_used : '未使用',
        expire: '已过期',
        used: '已使用',
 
      
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function user_growth_category_list(state) {
    const statusMap = {
        incr : '增加',
        decr: '减少',
        fix: '固定',
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function poster_list(state) {
    const statusMap = {
        popup : '弹窗',
        carousel: '轮播海报',
        share: '分享',
    };
    return statusMap[state] ? statusMap[state] : '';
}
